

import React from "react";
import { Form, useSearchParams } from "react-router";
import { ActionFunction, redirect } from "react-router";
import Auth from "~/services/auth/auth.server";
import { setToast } from "remix-toast/middleware";


export const action: ActionFunction = async ({ request, context }) => {
	try {
		const formData = await request.formData();
		const result = await Auth.Instance.signIn(
			formData.get("username")?.toString() || "",
			formData.get("password")?.toString() || "",
			formData.get("otp")?.toString() || ""
		);
		if (result) {
			return redirect("/", { headers: result ? { "Set-Cookie": result?.serialize() } : undefined });
		} else {
			return redirect("/auth/login?invalid=true");
		}
	} catch (e) {
		if (typeof e === "string") {
			setToast(context, { message: e, type: "error" });
			return {};
		} else if (e instanceof Error) {
			setToast(context, { message: e.message, type: "error" });
			return {};
		}
	}
};

export default function IndexView() {
	const [searchParams] = useSearchParams();
	const invalid = searchParams.get("invalid") === "true";
	return (
		<section className="hero is-primary is-large cs-fh-navbar cs-background-color-primary">
			<div className="hero-body">
				<div className="columns">
					<div className="column"></div>
					<div className="column">
						<div className="card">
							<header className="card-header">
								<p className="card-header-title">Login</p>
								<div className="card-header-icon">
									<span className="icon">
										<i className="ri-login-box-line" aria-hidden="true"></i>
									</span>
								</div>
							</header>
							<div className="card-content">
								<Form method="post">
									<div className="field">
										<label className="label">Benutzername</label>
										<div className="control has-icons-left">
											<input className={"input" + (invalid ? " is-danger": "")} name="username" type="text" placeholder="" />
											<span className="icon is-small is-left">
												<i className="ri-user-line"></i>
											</span>
										</div>
									</div>
									<div className="field">
										<label className="label">Passwort</label>
										<div className="control has-icons-left">
											<input className={"input" + (invalid ? " is-danger": "")} name="password" type="password" placeholder="" />
											<span className="icon is-small is-left">
												<i className="ri-lock-line"></i>
											</span>
										</div>
									</div>
									<div className="field">
										<label className="label">OTP</label>
										<div className="control has-icons-left">
											<input className={"input" + (invalid ? " is-danger": "")} name="otp" type="text" placeholder="" />
											<span className="icon is-small is-left">
												<i className="ri-lock-line"></i>
											</span>
										</div>
									</div>
									<div className="field is-grouped is-grouped-centered">
										<p className="control">
											<button type="submit" className="button is-link">Einloggen</button>
										</p>
									</div>
								</Form>
							</div>
						</div>

					</div>
					<div className="column"></div>
				</div>
			</div>
		</section>
	);
}
